import { CaretDownOutlined, DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { NavLink } from "react-router-dom";
import {  logout } from "../firebase";


const UserProfile = ({userName}) => {
  const items = [
    {
      label: <NavLink to="/propertymanagemnet">
      Profile: Property Management
    </NavLink>,
      key: "1",
    },
    {
      label: <NavLink to="/mysettings">My Settings</NavLink>,
      key: "2",
    },
    {
      label: <NavLink to="/generalSettings">General Settings</NavLink>,
      key: "3",
    },
    {
      label: <span onClick={logout}>Log Out</span>,
      key: "4",
    },
  ];
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
        <i
        className="fa fa-user-circle"
        aria-hidden="true"
        style={{ fontSize: "20px",marginRight:-10 }}
      ></i> {userName}
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  );
};
export default UserProfile;
